import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Button } from '@mui/material';
import { toast } from 'react-toastify';
import { triggerDatabricksJobData } from '../../Redux/DataBricks/CocaDataBricksSlice';

function CocaAnnual3() {
    const dispatch = useDispatch();

    const handleRunDataBricksJob = async () => {
        try {
            // 2 maps to CocaReport3JobID in your slice
            const action = await dispatch(triggerDatabricksJobData(2));
            if (triggerDatabricksJobData.fulfilled.match(action)) {
                const runId = action.payload.runId ?? 'N/A';
                toast.success(`Databricks job started (Run ID: ${runId})`);
            } else if (triggerDatabricksJobData.rejected.match(action)) {
                toast.error(action.payload || 'Failed to start Databricks job');
            }
        } catch (error) {
            toast.error('Failed to start Databricks job');
            console.error('Error triggering Databricks job:', error);
        }
    };

    return (
        <Box sx={{ margin: '20px 0' }}>
            <Button
                variant="contained"
                color="primary"
                onClick={handleRunDataBricksJob}
                sx={{ marginLeft: '10px' }}
            >
                Start New Run
            </Button>
        </Box>
    );
}

export default CocaAnnual3;